const initialState = {
    instanceId: 0
};
const instanceIdReducer = (state = initialState) => {
    return state;
};
export default instanceIdReducer;
